import { SellerRole } from '@/enums/seller.ts'
import i18n from '@/libs/i18n'
import type { NavLink } from '@/types/Navigation'

const { t } = i18n.global

export const getNavItems = (): NavLink[] => {
    return [
        {
            items: [
                // { label: t('general.dashboard'), icon: 'pi pi-fw pi-th-large', to: 'dashboard' },
                { label: t('lead.leads'), icon: 'pi pi-fw pi-id-card', to: 'leads' },
                { label: 'separator', icon: '', to: '' },
                { label: t('lead.sale'), icon: 'pi pi-fw pi-tag', to: 'sale-leads' },
                { label: t('lead.status.data_retrieval'), icon: 'pi pi-fw pi-database', to: 'data-retrieval-leads' },
                { label: t('lead.status.data_entry'), icon: 'pi pi-fw pi-database', to: 'data-entry-leads' },
                { label: t('lead.status.installation'), icon: 'pi pi-fw pi-wrench', to: 'installation-leads' },
                { label: t('lead.status.completed'), icon: 'pi pi-fw pi-check-circle', to: 'completed-leads' },
                { label: t('lead.status.rejected'), icon: 'pi pi-fw pi-times-circle', to: 'rejected-leads' },
                { label: t('lead.additional_requests.additional_requests'), icon: 'pi pi-fw pi-plus-circle', to: 'additional_requests' },
                { label: 'separator-red', icon: '', to: '' },
                { label: t('company.company', 2), icon: 'pi pi-fw pi-briefcase', to: 'companies' },
                { label: t('company.company_that_not_exists', 2), icon: 'ti ti-fw ti-briefcase-off', to: 'companies-that-not-exists' },
                { label: t('seller.seller', 2), icon: 'pi pi-users', to: 'sellers', requiredRoles: [SellerRole.MANAGE_USERS] }
            ]
        }
    ]
}
